import React from 'react';
import type { ManualTaskKind } from '../../api/laneApi';
import './lanes.css';

/**
 * Freshdesk #682 (John, 22 Oct): staff-sent and automatic multi-rep follow-ups
 * share ONE Manual-lane filter, "but the task show which was sent by staff and
 * that by automatic". The backend decides which (task_lane_service
 * .manual_task_kind, the Python mirror of the filter's own SQL) and sends it
 * as `manualKind`; this only words it. Every other kind renders nothing.
 */
const SENT_BY: Partial<Record<ManualTaskKind, { text: string; title: string }>> = {
  multi_rep_staff: {
    text: 'Sent by staff',
    title: 'Multi-rep email sent by a member of staff',
  },
  multi_rep_auto: {
    text: 'Sent automatically',
    title: 'Multi-rep email sent automatically',
  },
};

export const MultiRepSentByLabel: React.FC<{ kind?: ManualTaskKind | null }> = ({ kind }) => {
  const label = kind ? SENT_BY[kind] : undefined;
  if (!label) return null;
  return (
    <span className="manual-lane__sentby-label" title={label.title}>
      {label.text}
    </span>
  );
};

export default MultiRepSentByLabel;
